export const MESSAGE_REQUEST = "MESSAGE_REQUEST";
export const MESSAGE_GET_NEXT_SUCCESS = "MESSAGE_GET_NEXT_SUCCESS";
export const MESSAGE_GET_SUCCESS = "MESSAGE_GET_SUCCESS";
export const MESSAGE_ADD_SUCCESS = "MESSAGE_ADD_SUCCESS";
export const MESSAGE_UNREAD_ADD = "MESSAGE_UNREAD_ADD";
export const MESSAGE_UNREAD_REMOVE = "MESSAGE_UNREAD_REMOVE";
export const MESSAGE_FAIL = "MESSAGE_FAIL";
export const MESSAGE_CLEAR = "MESSAGE_CLEAR";
export const MESSAGE_DELETE = "MESSAGE_DELETE";